import React, {FC} from 'react';
import './children-link-list.scss';
import ServiceListItem from "../service-list-item/service-list-item.tsx"
import {stripHtml} from "mixins/helpers";

const ChildrenLinkList: FC = (props) => {
  return (
    <div className="children-link-list">
        {props.children.hits.map(x => (
            <ServiceListItem
                config={{
                  name: x.displayName,
                  preview: x.data
                      && x.data.description
                      && stripHtml(x.data.description).slice(0, 200) + '...'
                }}
                url={props.siteUrl + x._path.replace('/isna-portal-cms', '')}
            />
        ))}
    </div>
  );
};

export default (props) => <ChildrenLinkList {...props} />;
